<template>
  <el-row class="double-scroll">
    <el-col :span="leftSpan" class="left-col">
      <el-scrollbar height="100%"><slot name="left"></slot></el-scrollbar>
    </el-col>
    <el-col :span="rightSpan" class="right-col">
      <el-scrollbar height="100%"><slot name="right"></slot></el-scrollbar>
    </el-col>
  </el-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * 分割スクロール
 */
export default defineComponent({
  name: 'DoubleScroll',
  props: {
    leftSpan: {
      type: Number,
      required: false,
      default: 12,
    },
    rightSpan: {
      type: Number,
      required: false,
      default: 12,
    },
  },
})
</script>

<style lang="scss" scoped>
.el-row {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.el-col {
  height: 100%;
}
</style>
